import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
} from "@mui/material";

import { useParentChildGroups } from "../hooks";

export default function ParentChildGroupSelect({ sx = {} }) {
  const {
    loading,
    parentChildGroupOptions,
    selectedParentChildGroupId,
    setSelectedParentChildGroupId,
    showParentChildGroupSelect,
  } = useParentChildGroups();

  if (loading) {
    return (
      <Skeleton variant="rounded" sx={{ width: 220, height: 56, ...sx }} />
    );
  }

  if (!showParentChildGroupSelect) {
    return null;
  }

  return (
    <FormControl sx={{ minWidth: 220, ...sx }}>
      <InputLabel id="parent-child-group-select-label">Group</InputLabel>
      <Select
        labelId="parent-child-group-select-label"
        value={selectedParentChildGroupId ?? ""}
        label="Group"
        onChange={(event) => {
          setSelectedParentChildGroupId(event.target.value);
        }}
      >
        {parentChildGroupOptions.map((group) => (
          <MenuItem
            key={`parent-child-group-${group.organizationId}`}
            value={group.organizationId}
          >
            {group.organizationName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
